import React, { PureComponent } from 'react'
import cx from 'classnames'
import moment from 'moment'
import SvgIcon from 'src/components/SvgIcon'

import styles from './NotificationBanner.module.less'

import {
  setNotificationCookieHidden,
  getNotificationCookieHidden,
  getKioskDocument
} from 'src/utils/helpers'

class NotificationBanner extends PureComponent {

  calculateNotificationHeight() {
    
    const doc = getKioskDocument()
    const { setNotificationHeight } = this.props;
    const notificationMinHeight = 76

    let elementHeight = notificationMinHeight;

    // there are two banners one in AppLayout, another in Sidebar 
    let elements = doc.querySelectorAll('.notification-banner')
    if(elements.length) {
      if(elements[0] && elements[0].offsetHeight) {
        elementHeight = elements[0].offsetHeight
      }else if(elements[1] && elements[1].offsetHeight) {
        elementHeight = elements[1].offsetHeight 
      }
    }
    setNotificationHeight(elementHeight)
  }

  componentDidUpdate() {
    this.calculateNotificationHeight()
  }

  componentDidMount() {
    const { history, setNotificationBannerHidden } = this.props
    this.renderNotification()
    window.addEventListener('resize', this.calculateNotificationHeight.bind(this));

    this.unlisten = history.listen(() => {
      if (history.location.pathname === '/chat' && getKioskDocument().body.clientWidth <= 990) {
        setNotificationBannerHidden(true)
        return
      }
      this.renderNotification()
    })
  }

  componentWillUnmount() {
    this.unlisten()
    window.removeEventListener('resize', this.calculateNotificationHeight.bind(this));
  }

  renderNotification = () => {
    
    const { areAppActionsDisabled, bannerNotification, setNotificationBannerHidden } = this.props
    this.calculateNotificationHeight();
    if (bannerNotification && bannerNotification.enableNotificationBanner && !areAppActionsDisabled) {
      const isSameDate = moment(bannerNotification.dateFrom).isSame(new Date(), "day") || moment(bannerNotification.dateTo).isSame(new Date(), "day");
      if (getNotificationCookieHidden()) {
        setNotificationBannerHidden(true)  
        return
      }
      if ((moment().isAfter(bannerNotification.dateFrom) && moment().isBefore(bannerNotification.dateTo)) || isSameDate) {
        setNotificationBannerHidden(false)
      }else {
        setNotificationBannerHidden(true)
      }
    } else {
      setNotificationBannerHidden(true)
    }
  }
  hideBanner = () => {
    const {
      setNotificationBannerHidden,
    } = this.props
    setNotificationCookieHidden(true)
    setNotificationBannerHidden(true)
  }

  
  render() {
    const { className, isNotificationHidden, bannerNotification, areAppActionsDisabled } = this.props

    const classNames = cx({
      'notification-banner': true,
      [className]: !!className,
      [styles.notificationBannerContainer]: true,
    })

    return (!isNotificationHidden && !areAppActionsDisabled ? <div className={classNames}>
      <div className={styles.closeIconHolder} onClick={this.hideBanner}>
        <SvgIcon type="RemoveThinner" className={styles.closeIcon} />
      </div>
      <div className={styles.notificationIconHolder}>
        <SvgIcon type="Bell" className={styles.notificationIcon} />
      </div>
      <p className={styles.notificationMessage} dangerouslySetInnerHTML={{ __html: bannerNotification.bannerMessage.replaceAll('<a', '<a target="_blank"') }}>
      </p>
    </div> : null)
  }
}


export default NotificationBanner

